<template>
    <div>
        <AddRowAbove :Editor="Editor"></AddRowAbove>
        <AddRowBellow :Editor="Editor"></AddRowBellow>
        <RemoveRow :Editor="Editor"></RemoveRow>
        <AddColumnLeft :Editor="Editor"></AddColumnLeft>
        <AddColumnRight :Editor="Editor"></AddColumnRight>
        <RemoveColumn :Editor="Editor"></RemoveColumn>
    </div>
</template>
<script>

import AddRowBellow from '@/views/components/atoms/tiptap/Predefined/Buttons/Table/AddRowBellow.vue';
import AddColumnLeft from '@/views/components/atoms/tiptap/Predefined/Buttons/Table/AddColumnLeft.vue';
import AddColumnRight from '@/views/components/atoms/tiptap/Predefined/Buttons/Table/AddColumnRight.vue';
import AddRowAbove from '@/views/components/atoms/tiptap/Predefined/Buttons/Table/AddRowAbove.vue';
import RemoveRow from '@/views/components/atoms/tiptap/Predefined/Buttons/Table/RemoveRow.vue';
import RemoveColumn from '@/views/components/atoms/tiptap/Predefined/Buttons/Table/RemoveColumn.vue';

export default ({
    components: {
        AddRowBellow,
        RemoveRow,
        AddRowAbove,
        AddColumnLeft,
        AddColumnRight,
        RemoveColumn
    },
    props: ["Editor"]
});
</script>